/**
 * How a role's REACH is described in the pickers.
 *
 * Two roles here are both `fullAccess` and they are not the same thing, which
 * is the exact confusion this exists to end: `Administrator` holds every
 * permission in the catalog but only inside the tenant the membership names,
 * while `super-admin` is the platform role — assigning it sets
 * `User.isSuperAdmin`, which is the only thing the backend's global routes
 * (Users, Roles, Feature Flags, Products, DIN Configure) consult.
 *
 * Labelling both "· all permissions" is what made picking Administrator look
 * broken: all 74 keys, and the admin screens stayed shut.
 */

/** Slug of the platform role. The backend keys off this exact string. */
export const PLATFORM_ROLE_SLUG = 'super-admin'

export function isPlatformRole(role: { slug: string }): boolean {
  return role.slug === PLATFORM_ROLE_SLUG
}

/**
 * The muted suffix beside a role name, or null when the role's permission set
 * speaks for itself (a partial role's reach is just what it lists).
 */
export function roleAccessHint(role: { slug: string; fullAccess: boolean }): string | null {
  if (isPlatformRole(role)) return 'platform-wide · every tenant + admin screens'
  if (role.fullAccess) return 'all permissions in this tenant'
  return null
}
